export const BACKEND_FIELD_MAP = {

    // frontendKey : backendKey
    // Personal Information Keys
    surname: "surname",
    given_name: "given_name",
    gender: "gender",
    date_of_birth: "date_of_birth",
    town_city_of_birth: "town_city_of_birth",
    country_of_birth: "country_of_birth",
    religion: "religion",
    name_change: "name_changed",
    previous_surname: "previous_surname",
    previous_given_name: "previous_given_name",
    nationality: "nationality",
    citizenship_national_id: "citizenship_national_id",
    nationality_acquisition: "nationality_acquisition",
    previous_nationality: "prev_nationality",
    educational_qualification: "educational_qualification",
    acquired_qualification: "acquired_qualification",
    lived_2_years: "lived_2_years",

    //   Family Keys
    father_name: "father_name",
    father_nationality: "father_nationality",
    father_pob: "father_pob",
    father_cob: "father_cob",
    mother_name: "mother_name",
    mother_nationality: "mother_nationality",
    mother_pob: "mother_pob",
    mother_cob: "mother_cob",
    marital_status: "marital_status",
    spouse_name: "spouse_name",
    spouse_nationality: "spouse_nationality",
    spouse_birth_place: "spouse_birth_place",
    spouse_birth_country: "spouse_birth_country",
    pak_heritage: "pak_heritage",
    pak_heritage_details: "pak_heritage_details",

    // Employment Section
    occupation: "occupation",
    employer_name: "employer_name",
    designation: "designation",
    employer_address: "employer_address",
    employer_phone: "employer_phone",
    military_service: "military_service",
    military_organization: "military_organization",
    military_designation: "military_designation",
    military_rank: "military_rank",
    military_posting: "military_posting",
    applicant_company_name: "applicant_company_name",
    applicant_company_website: "applicant_company_website",
    applicant_company_address_phone: "applicant_company_address_phone",
    nature_of_business_product: "nature_of_business_product",


    // Passport Section
    passport_type: "passport_type",
    passport_number: "passport_number",
    passport_place_of_issue: "passport_place_of_issue",
    passport_date_of_issue: "passport_date_of_issue",
    passport_date_of_expiry: "passport_date_of_expiry",
    has_other_passport: "has_other_passport",
    other_passport_no: "other_passport_no",
    other_passport_country: "other_passport_country",
    other_passport_poi: "other_passport_poi",
    other_passport_doi: "other_passport_doi",
    other_passport_nationality: "other_passport_nationality",


    // // Address Section
    present_address_street: "present_address_street",
    present_address_city: "present_address_city",
    present_address_state: "present_address_state",
    present_address_zip: "present_address_zip",
    present_address_country: "present_address_country",
    present_phone: "present_phone",
    same_as_present_address: "same_as_present_address",
    permanent_street: "permanent_street",
    permanent_city: "permanent_city",
    permanent_state: "permanent_state",

    // Refernces
    reference_india_name: "reference_india_name",
    reference_india_address: "reference_india_address",
    reference_india_phone: "reference_india_phone",
    reference_home_name: "reference_home_name",
    reference_home_address: "reference_home_address",
    reference_home_phone: "reference_home_phone",

    // Travel 
    port_of_arrival: "port_of_arrival",
    exit_port:"exit_port",
    expected_date_of_arrival: "expected_date_of_arrival",
    places_to_visit: "places_to_visit",
    hotel_booking: "hotel_booking",
    hotel_resort_name: "hotel_resort_name",
    hotel_resort_city: "hotel_resort_city",
    visited_india_before: "visited_india_before",
    prev_stay_address: "prev_stay_address",
    last_visa_no: "last_visa_no",
    last_visa_type: "last_visa_type",
    last_visa_poi: "last_visa_poi",
    last_visa_doi: "last_visa_doi",
    cities_visited: "cities_visited",
    permission_refused: "permission_refused",
    refusal_details: "refusal_details",
    countries_visited_10_years: "countries_visited_10_years",
    saarc_visit: "saarc_visit",
   

    // Declaration
    arrested: "arrested",
    arrested_details: "arrested_details",
    deported: "deported",
    deported_details: "deported_details",
    human_trafficking: "human_trafficking",
    ht_details: "ht_details",
    cyber_crime: "cyber_crime",
    cyber_details: "cyber_details",
    extremist_views: "extremist_views",
    extremist_details: "extremist_details",
    asylum: "asylum",
    asylum_details: "asylum_details",

};
